import { IosShare, MoreHoriz } from "@mui/icons-material";
import { AlertProps } from "@mui/material";
import { t } from "i18next";
import { Trans } from "react-i18next";
import AlertDefault, { AlertVariant } from "../Alerts/AlertDefault";
import ButtonDefault from "../Button/ButtonDefault";
import Text from "../Text/Text";
import { BeforeInstallPromptEvent, installMessage } from "./InstallApp";

type InstallAppAlertProps = {
  canClose?: boolean;
  deferredPrompt: BeforeInstallPromptEvent | null;
  handleInstallClick: () => void;
  onClose: () => void;
  installMessage: installMessage;
} & AlertProps;

const InstallAppAlert = ({
  canClose,
  deferredPrompt,
  handleInstallClick,
  installMessage,
  ...props
}: InstallAppAlertProps) => {
  return (
    <div className="w-full absolute z-50">
      <AlertDefault
        variant={AlertVariant.CallToAction}
        canClose
        onClose={() => {
          props.onClose != undefined && props.onClose();
        }}
        bottomElement={
          deferredPrompt ? (
            <div className="my-2 -mx-10">
              <ButtonDefault
                id="install"
                onClick={handleInstallClick}
                label={t("installApp.buttonText")}
              />
            </div>
          ) : (
            <></>
          )
        }
      >
        <div className="-mt-1.5">
          <Text bold className="tablet:!text-2xl mb-2! tablet:!mb-4">
            {t("installApp.title")}
          </Text>
          <Text className="tablet:!text-2xl mb-2!">
            <Trans
              i18nKey={
                installMessage === "can-install"
                  ? "installApp.message"
                  : installMessage === "safari-modern"
                    ? "installApp.fallbackMessageModern"
                    : "installApp.fallbackMessage"
              }
              components={{
                iconMore: (
                  <MoreHoriz
                    aria-label={t("actions.more")}
                    titleAccess={t("actions.more")}
                    style={{
                      fontSize: "1.5rem",
                    }}
                  />
                ),
                iconShare: (
                  <IosShare
                    aria-label={t("actions.share")}
                    titleAccess={t("actions.share")}
                    style={{
                      fontSize: "1.5rem",
                    }}
                  />
                ),
              }}
            />
          </Text>
        </div>
      </AlertDefault>
      <div
        className={`w-full max-w-244 absolute z-40 h-2 bg-linear-to-b from-ldir-brown-900/40 to-transparent transition-opacity duration-500 pointer-events-none`}
      />
    </div>
  );
};

export default InstallAppAlert;
